<template>
  <div @click="openDropdown = false">
    <div class="space-y-4">
      <div class="flex justify-between">
        <h2 class="font-semibold uppercase text-gray-600">Drivers</h2>
        <router-link
          to="/drivers/add"
          class="px-4 py-2 bg-blue-500 text-white font-semibold rounded hover:bg-blue-700"
        >
          Add Driver
        </router-link>
      </div>

      <div class="flex justify-between">
        <div class="relative max-w-sm w-full">
          <div class="absolute inset-y-0 flex items-center px-3">
            <i class="material-icons text-gray-500">search</i>
          </div>
          <input
            @keyup="search"
            class="rounded border pl-10 pr-4 py-2 w-full"
            placeholder="Search"
          />
        </div>
        <div class="w-64">
          <select class="form-select w-full" @change="setApprovedFilter">
            <option :selected="selectedApprovedFilter === 'both'" value="both">
              All Status
            </option>
            <option
              :selected="selectedApprovedFilter === 'approved'"
              value="approved"
            >
              Approved
            </option>
            <option
              :selected="selectedApprovedFilter === 'unapproved'"
              value="unapproved"
            >
              Unapproved
            </option>
          </select>
        </div>
      </div>

      <div class="inline-block min-w-full shadow rounded-lg mt-4">
        <table class="min-w-full leading-normal">
          <thead>
            <tr>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Name
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Email
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Contact Number
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Rating
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Balance
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Vehicle Type
              </th>
              <th
                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
              >
                Status
              </th>
              <th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100"></th>
            </tr>
          </thead>
          <tbody class="relative" v-if="drivers.length">
            <tr v-for="(driver, index) in drivers" :key="driver._id">
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <div class="flex items-center space-x-2">
                  <div class="relative">
                    <div class="h-12 w-12 rounded-full overflow-hidden">
                      <!-- <div
                        class="h-12 w-12 rounded-full border-4 border-green-500 overflow-hidden"
                      > -->
                      <img
                        :src="driver.profileImage"
                        :alt="driver.firebaseId"
                      />
                      <div
                        class="absolute right-0 bottom-0 h-3 w-3 rounded-full bg-green-500"
                      ></div>
                    </div>
                  </div>
                  <div>
                    <router-link
                      :to="`/drivers/${driver._id}`"
                      class="whitespace-no-wrap"
                    >
                      {{ driver.firstName + " " + driver.lastName }}
                    </router-link>
                    <p class="whitespace-no-wrap text-gray-600">
                      {{ driver._id }}
                    </p>
                  </div>
                </div>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ driver.email }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">
                  {{ driver.phoneNumber }}
                </p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">0.0</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">{{ driver.ballance.toFixed(2) }}</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                <p class="text-gray-900 whitespace-no-wrap">Type</p>
              </td>
              <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                {{ driver.approved ? "Approved" : "Not Approved" }}
              </td>
              <td
                class="px-5 py-5 border-b border-gray-200 bg-white text-sm text-right"
              >
                <div @click.stop class="relative inline-block text-left">
                  <div>
                    <span class="rounded-md shadow-sm">
                      <button
                        @click="toggleDropdown(index)"
                        type="button"
                        class="inline-flex justify-center w-full rounded-md px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition ease-in-out duration-150"
                        aria-haspopup="true"
                        :aria-expanded="openDropdown === index"
                      >
                        <i class="material-icons">more_vert</i>
                      </button>
                    </span>
                  </div>
                  <transition
                    enter-active-class="transition ease-out duration-100"
                    enter-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95"
                  >
                    <div
                      v-if="openDropdown === index"
                      class="origin-top-right absolute right-0 w-56 rounded-md shadow-lg z-10"
                    >
                      <div
                        class="rounded-md bg-white shadow-xs"
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="options-menu"
                      >
                        <div class="py-1">
                          <router-link
                            :to="`rides?driver=${driver._id}`"
                            class="flex items-center space-x-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            <i class="material-icons">history</i>
                            <span>Ride History</span>
                          </router-link>
                          <!-- <a
                            href="#"
                            class="block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                            >Statement</a
                          > -->
                        </div>
                        <div class="py-1" v-if="role == 1">
                          <router-link
                            :to="`wallet-managment?driver=${driver._id}`"
                            class="flex items-center space-x-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            <i class="material-icons">account_balance_wallet</i>
                            <span>Topup</span>
                          </router-link>
                        </div>
                        <div class="border-t border-gray-100"></div>
                        <div class="py-1">
                          <router-link
                            :to="`drivers/${driver._id}/edit`"
                            class="flex items-center space-x-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            <i class="material-icons">edit</i>
                            <span>Edit</span>
                          </router-link>
                          <button
                            @click="toggleApproval(driver._id)"
                            type="button"
                            class="w-full flex items-center space-x-2 px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900"
                            role="menuitem"
                          >
                            <i v-if="driver.approved" class="material-icons">
                              close
                            </i>
                            <i v-else class="material-icons">check</i>
                            <span>{{
                              driver.approved ? "Disapprove" : "Approve"
                            }}</span>
                          </button>
                        </div>
                        <!-- <div class="border-t border-gray-300"></div>
                        <div class="py-1">
                          <button
                            @click="openConfirmBox"
                            type="button"
                            class="flex w-full items-center space-x-2 px-4 py-2 text-sm leading-5 text-red-700 hover:bg-red-200 hover:text-red-800 focus:outline-none focus:bg-red-200 focus:text-red-800"
                            role="menuitem"
                          >
                            <i class="material-icons">delete</i>
                            <span>Delete</span>
                            <portal to="modals">
                              <transition
                                enter-active-class="transition ease-out duration-100"
                                enter-class="transform opacity-0 scale-95"
                                enter-to-class="transform opacity-100 scale-100"
                                leave-active-class="transition ease-in duration-75"
                                leave-class="transform opacity-100 scale-100"
                                leave-to-class="transform opacity-0 scale-95"
                              >
                                <div
                                  v-if="confirmOpen"
                                  @click="closeConfirmBox"
                                  class="absolute inset-0 flex items-center justify-center bg-black bg-opacity-25 z-40"
                                >
                                  <div
                                    @click.stop
                                    class="bg-white w-full max-w-lg rounded-lg overflow-hidden shadow-lg"
                                  >
                                    <div class="bg-gray-100">
                                      <h3
                                        class="px-6 py-4 font-semibold text-gray-600"
                                      >
                                        Confirm Delete
                                      </h3>
                                    </div>
                                    <div
                                      class="flex items-center space-x-4 px-6 py-6"
                                    >
                                      <i class="material-icons text-4xl">
                                        warning
                                      </i>
                                      <div>
                                        <p>
                                          Are you sure you want to delete this
                                          driver?
                                        </p>
                                        <p>
                                          <em class="text-gray-600 text-sm">
                                            This action can not be undone!
                                          </em>
                                        </p>
                                      </div>
                                    </div>
                                    <hr />
                                    <div
                                      class="flex items-end justify-between px-6 py-4"
                                    >
                                      <button
                                        @click="closeConfirmBox"
                                        type="button"
                                        class="px-4 py-2 text-gray-600 hover:text-gray-900"
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        @click="deleteDriver(driver._id)"
                                        type="button"
                                        :disabled="deleting"
                                        class="flex items-center space-x-2 px-4 py-2 font-semibold border border-transparent rounded shadow-sm"
                                        :class="
                                          deleting
                                            ? 'bg-red-100 text-red-500 cursor-not-allowed'
                                            : 'bg-red-200 text-red-700 hover:text-red-800 hover:border-red-800'
                                        "
                                      >
                                        <i
                                          v-if="deleting"
                                          class="material-icons spin text-red-700"
                                        >
                                          sync
                                        </i>
                                        <i v-else class="material-icons">
                                          delete
                                        </i>
                                        <span>Delete</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </transition>
                            </portal>
                          </button>
                        </div> -->
                      </div>
                    </div>
                  </transition>
                </div>
              </td>
            </tr>
            <div
              v-if="loading"
              class="absolute inset-0 h-full w-full flex items-center justify-center bg-black bg-opacity-25"
            >
              <i class="material-icons text-6xl spin">sync</i>
              <span class="block invisible">Loading...</span>
            </div>
          </tbody>
          <tbody v-else>
            <tr>
              <td
                colspan="7"
                class="bg-white py-4 text-center text-gray-600 font-semibold"
              >
                <div v-if="loading" class="inline-block">
                  <i class="material-icons text-6xl spin">sync</i>
                  <span class="block invisible">Loading...</span>
                </div>
                <div v-else class="inline-block">
                  <i class="material-icons text-6xl">warning</i>
                  <span class="block">No latest rides!</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex justify-between items-end" v-if="!results.length">
        <p class="text-gray-600">
          Showing <strong>{{ start }}</strong> to <strong>{{ end }}</strong> of
          <strong>{{ paginator.count }}</strong> entries
        </p>
        <div class="flex items-center space-x-4">
          <div>
            Per page:
            <select
              class="form-select"
              name="perPage"
              id="perPage"
              @change="setPerPage"
            >
              <option :selected="perPage === '10'" value="10">10</option>
              <option :selected="perPage === '25'" value="25">25</option>
              <option :selected="perPage === '50'" value="50">50</option>
              <option :selected="perPage === '100'" value="100">100</option>
            </select>
          </div>
          <div class="space-x-2 flex">
            <button
              @click="goToPrev"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_left</i>
            </button>
            <button
              v-for="page in total"
              :key="`pageLink-${page}`"
              type="button"
              class="p-2"
              :class="{
                'text-gray-500 hover:text-gray-800': currentPage !== page,
                'text-gray-900': currentPage === page,
              }"
              :disabled="currentPage === page"
              @click="goToPage(page)"
            >
              {{ page }}
            </button>
            <button
              @click="goToNext"
              type="button"
              class="flex items-center p-2 text-gray-500 hover:text-gray-800 outline-none focus:outline-none"
            >
              <i class="material-icons">chevron_right</i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Pagination from "@/mixins/Pagination";

export default {
  mixins: [Pagination],
  data() {
    return {
      allDrivers: [],
      openDropdown: false,
      loading: true,
      confirmOpen: false,
      deleting: false,
      results: [],
      selectedApprovedFilter: "both",
    };
  },
  created() {
    this.getDrivers();
  },
  mounted() {
    document.body.addEventListener("keyup", this.escapeListener);
  },
  beforeDestroy() {
    document.body.removeEventListener("keyup", this.escapeListener);
  },
  watch: {
    selectedApprovedFilter() {
      this.getDrivers();
    },
    currentPage() {
      this.getDrivers();
    },
    perPage() {
      this.currentPage === 1 ? this.getDrivers() : (this.currentPage = 1);
    },
  },
  computed: {
    role() {
      return this.$store.state.role
    },
    drivers() {
      return this.results.length ? this.results : this.allDrivers;
    },
  },
  methods: {
    setApprovedFilter(e) {
      this.selectedApprovedFilter = e.target.value;
    },
    escapeListener(e) {
      if (e.keyCode === 27) {
        this.closeConfirmBox();
      }
    },
    getDrivers() {
      let filter;

      if (this.selectedApprovedFilter === "approved") {
        filter = true;
      } else if (this.selectedApprovedFilter === "unapproved") {
        filter = false;
      } else {
        filter = null;
      }

      this.loading = true;
      this.$http
        .get(
          `drivers?page=${this.currentPage}&limit=${this.perPage}&${
            filter !== null ? "approved=" + filter : ""
          }`
        )
        .then(response => {
          this.allDrivers = response.data.data;
          this.paginator = {
            nextPage: response.data.nextPage,
            prevPage: response.data.prevPage,
            count: response.data.count,
          };
        })
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    toggleDropdown(index) {
      if (this.openDropdown === index) {
        this.openDropdown = false;
      } else {
        this.openDropdown = index;
      }
    },
    openConfirmBox() {
      this.confirmOpen = true;
    },
    closeConfirmBox() {
      this.confirmOpen = false;
    },
    // deleteDriver(id) {
    //   this.deleting = true;
    //   this.$http
    //     .delete(`drivers/${id}`)
    //     .then(result => console.log(result))
    //     .catch(err => console.log(err))
    //     .finally(() => {
    //       this.deleting = false;
    //       this.confirmOpen = false;
    //       this.openDropdown = false;
    //       this.getDrivers();
    //     });
    // },
    search: _.debounce(function (e) {
      if (e.target.value.trim() === "") {
        this.results = [];
        return;
      }

      this.$http
        .get(`/drivers/search?q=${e.target.value}`)
        .then(response => {
          this.results = response.data;
        })
        .catch(err => console.log(err));
    }, 500),
    toggleApproval(id) {
      const currentStatus = this.drivers.find(driver => driver._id === id)
        .approved;
      this.$http
        .patch(`/drivers/${id}`, {
          approved: !currentStatus,
        })
        .then(() => {
          window.flash({
            type: "success",
            body: currentStatus ? "Driver disapproved!" : "Driver approved!",
          });
          this.getDrivers();
        })
        .catch(err => {
          window.flash({ type: "error", body: "Failed to approve driver!" });
          console.log(err);
        })
        .finally(() => (this.openDropdown = false));
    },
  },
};
</script>
